<div class="row">
	<div class="col-12 col-lg-6">
		<app-dynamic-breadcrumb [bgColor]="'transparent'" [fontSize]="'14px'"
			[lastLinkColor]="'rgba(196, 196, 205, 0.42)'" [fontColor]="'#c4c4cd'" class="last-cap">
		</app-dynamic-breadcrumb>
	</div>
</div>
<div class="row">
  <div class="col-12">
    <div class="row header">Ref Data Table Selection Details</div>
    <app-shared-ref-data></app-shared-ref-data>
  </div>
</div>

